// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","ProductBuyerHeader":"cz_a bhu_rl","ProductBuyerHeader__username":"cz_b bhu_ua"};